import React, { useState } from 'react';
import { createFee } from '../utils/api';

const CreateFeeModal = ({ closeModal, refreshData }) => {
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handleCreate = async () => {
        if (!name || !amount) {
            setErrorMessage('Name and amount are required.');
            return;
        }
        try {
            const payload = {
                name,
                amount: parseFloat(amount) * 100
            };

            if (description) {
                payload.description = description;
            }

            await createFee(payload);
            closeModal();
            refreshData();
        } catch (error) {
            setErrorMessage(error.message);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Create Fee</h2>
                    <button onClick={closeModal} className="modal-close">&times;</button>
                </div>
                <div className="modal-body">
                    {errorMessage && <p className="error">{errorMessage}</p>}
                    <div className="form-group">
                        <input
                            type="text"
                            id="name"
                            placeholder="Name"
                            value={name}
                            onChange={e => setName(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            id="description"
                            placeholder="Description"
                            value={description}
                            onChange={e => setDescription(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <input
                            type="number"
                            id="amount"
                            placeholder="Amount"
                            value={amount}
                            onChange={e => setAmount(e.target.value)}
                        />
                    </div>
                </div>
                <div className="actions-centered">
                    <button onClick={closeModal} className="cancel-button text-button">Cancel</button>
                    <button onClick={handleCreate} className="submit-button text-button">Create</button>
                </div>
            </div>
        </div>
    );
};

export default CreateFeeModal;